<template>
  <div v-if="businessRegistrationData">
    <v-card>
      <v-card-title>
        <div>
         {{editStep>1 ? 'در حال تکمیل اطلاعات' : ' ویرایش اطلاعات' }}
          {{ businessRegistrationData.isSupplier ? 'کسب و کار' : 'خریدار' }}
        </div>
        <v-spacer></v-spacer>
        <v-btn color="primary" icon @click="closeEditForm()">
          <v-icon>mdi mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <business-registration
          :isEdit="true"
          :businessRegistrationData="businessRegistrationData"
          @closeForm="closeEditForm"
          :editStep="editStep"
          :isCompletingData="editStep >0"
        ></business-registration>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Helper from '@/core/helpers';
import BusinessRegistration from '@/components/businessInformation/form/BusinessRegistration.vue';
import { RepoFactory } from '@/baseRepository/Factory';
import Swal from 'sweetalert2';
const merchantRepository = () => RepoFactory.get('merchant');
export default {
  components: {
    BusinessRegistration,
  },
  data() {
    return {
      businessRegistrationData: null,
      editStep:1,
    };
  },
  created() {
    this.editStep = parseInt(this.$route.params.stepId)
     console.log("Created value of this.editStep",this.editStep)
    this.getData();
  },
  computed: {
    computedMerchantId() {
      if (this.$store.getters.currentUserIsVisitor) {
        return this.$route.params.id;
      }
      else {
        return null;
      }
    },
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
  },
  methods: {
    closeEditForm() {
      if (this.$store.getters.currentUserIsVisitor) {
        this.$router.replace({ path: '/merchant-companies/list' });
      }
      else {
        this.$router.replace({ path: '/business-information' });
        
      }
    },
    getData() {
      if (!this.$store.getters.userDetails.roles.includes('supplier') && !this.$store.getters.currentUserIsVisitor) {
        this.getSupplierInformation();
      } else if (this.$store.getters.currentUserIsVisitor) { 
        
        this.getSupplierInformationById();
      } 
      else {
        if (this.currentMerchant) {
          this.getMerchantInformation();
        }
      }
    },
    getSupplierInformation() {
      const loader = this.$loading.show();
      this.$store
        .dispatch('getSupplierInformation')
        .then((data) => {
          this.businessRegistrationData = data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getMerchantInformation() {
      const loader = this.$loading.show();
      this.$store
        .dispatch('getMerchantInformation')
        .then((data) => {
          this.businessRegistrationData = data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getSupplierInformationById() {
    
        merchantRepository()
        .getMerchantInformationById(this.computedMerchantId, this.merchantBaseUrl)
          .then(({ data }) => {
          
          this.businessRegistrationData = data;
          console.log("this.businessRegistrationData",this.businessRegistrationData)
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
  },
};
</script>

<style></style>
